module.exports = __webpack_public_path__ + "img/5.a041964f.png";